import { Directive } from '@angular/core';
import * as moment from 'moment';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
	selector: '[dateValidator]',
	providers: [{ provide: NG_VALIDATORS, useExisting: DateValidator, multi: true }]
})
export class DateValidator implements Validator {
	validate(control: AbstractControl): { [key: string]: any } | null {
		let dateValue = new Date(control.value);
		let momentDateValue: moment.Moment;
		if (control.value && dateValue.toString() != 'Invalid Date') {
			if (control.value.toString().indexOf('T') > -1) {
				momentDateValue = moment(control.value);
			} else {
				momentDateValue = moment(control.value, 'MM/DD/YY');
			}
		}
		if (!control.value || dateValue.toString() != 'Invalid Date') {
			if (momentDateValue != undefined && momentDateValue.toString().toLocaleLowerCase() == 'invalid date') {
				return { 'invalidDate': true };
			} else {
				return null;
			}
		} else {
			return { 'invalidDate': true };
		}
	}
}
